import React, { useMemo } from 'react';
import TypistCycle from './TypistCycle';
import heroBackground640 from './coding-640.webp';
import heroBackground960 from './coding-960.webp';
import heroBackground1200 from './coding.webp';

const Hero = () => {
  const cycleContent = useMemo(
    () => [
      'Full Stack Developer',
      'C# Specialist',
      'Data Structures & Algorithms Enthusiast',
      'JavaScript Problem Solver',
      'React.js Engineer',
      'DevOps Collaborator',
      'Integration Engineer'
    ],
    []
  );

  return (
    <section id="hero" className="section-hero" aria-labelledby="hero-title">
      <picture className="hero-background" aria-hidden="true">
        <source
          type="image/webp"
          srcSet={`${heroBackground640} 640w, ${heroBackground960} 960w, ${heroBackground1200} 1200w`}
          sizes="(max-width: 640px) 640px, (max-width: 1024px) 960px, 1200px"
        />
        <img
          src={heroBackground960}
          alt=""
          loading="eager"
          decoding="async"
          fetchpriority="high"
          width="1200"
          height="800"
        />
      </picture>
      <div className="hero-overlay" aria-hidden="true" />
      <div className="hero-content">
        <p className="hero-kicker">Hello, I'm</p>
        <h1 id="hero-title">Rajendra Pareek</h1>
        <p className="hero-subtitle">
          Full stack developer in Jodhpur, India focused on C#, React, and SQL Server, translating complex ideas into intuitive,
          performant software experiences.
        </p>
        <TypistCycle
          content={cycleContent}
          numberOfCycles={-1}
          segmentDelay={1}
          typingDelay={80}
          className="hero-typist"
        />
        <div className="hero-actions">
          <a className="btn btn-primary" href="#case-studies">
            Explore my work
          </a>
          <a
            className="btn btn-ghost"
            href="https://www.linkedin.com/in/rpareek347/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn Profile
          </a>
        </div>
      </div>
      <a className="hero-scroll-indicator" href="#about-me" aria-label="Scroll to learn more about Rajendra Pareek">
        <span aria-hidden="true">v</span>
      </a>
    </section>
  );
};

export default Hero;
